import { render, staticRenderFns } from "./PdfFileView.vue?vue&type=template&id=2db88411&scoped=true&"
import script from "./PdfFileView.vue?vue&type=script&lang=ts&"
export * from "./PdfFileView.vue?vue&type=script&lang=ts&"
import style0 from "./PdfFileView.vue?vue&type=style&index=0&id=2db88411&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db88411",
  null
  
)

export default component.exports